import * as React from "react";
import { Text } from "@uikit";
import { CourseReview } from "@kalabo/golfsavers-common";
import dayjs from "dayjs";
import StarRating from "../../../starRating";
import { ChevronDownIcon } from "@heroicons/react/outline";

interface IReviewItemProps {
  data: CourseReview;
  truncated?: boolean;
}

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

const ReviewItem = ({ data, truncated = true }: IReviewItemProps) => {
  const { title, created_at, name, overall, review } = data;

  const [overflowActive, setOverflowActive] = React.useState<boolean>(false);
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const overflowingText = React.useRef<HTMLSpanElement | null>(null);

  React.useEffect(() => {
    if (checkOverflow(overflowingText.current)) {
      setOverflowActive(true);
      return;
    }

    setOverflowActive(false);
  }, [overflowActive]);

  const checkOverflow = (textContainer: HTMLSpanElement | null): boolean => {
    if (textContainer)
      return (
        textContainer.offsetHeight < textContainer.scrollHeight ||
        textContainer.offsetWidth < textContainer.scrollWidth
      );
    return false;
  };

  let reviewTitle = () => {
    return title.charAt(0).toUpperCase() + title.slice(1);
  };

  return (
    <div className="flex flex-col">
      <div className="flex items-center mt-1 mb-2">
        <div className="flex justify-center mr-2">
          <StarRating hideCount rating={overall} size="medium" />
        </div>
        <Text size={11} leading={1.3} color="black80">
          <>
            {name}, {dayjs(created_at.toString()).format("MMM DD, YYYY")}
          </>
        </Text>
      </div>
      <Text
        size={17}
        element="h3"
        weight="semibold"
        leading={1.3}
        color="black90"
      >
        {reviewTitle()}
      </Text>
      <span
        ref={overflowingText}
        className={`text-black/80 text-left leading-[150%] mt-[5px] text-15 ${
          truncated ? (expanded ? "" : "line-clamp-3") : ""
        }`}
      >
        {review}
      </span>
      {overflowActive && truncated && (
        <>
          <div
            className={` !text-black cursor-pointer text-15 flex items-end mt-2 relative z-10`}
            onClick={() => {
              setExpanded(!expanded);
            }}
          >
            <>
              <span className="underline font-semibold">
                {!expanded ? "Read More" : "Read Less"}{" "}
              </span>
              <ChevronDownIcon
                className={`inline h-5 w-5 text-black ${
                  expanded && "rotate-180"
                }`}
                aria-hidden="true"
              />
            </>
          </div>
        </>
      )}
    </div>
  );
};

export default ReviewItem;
